import { apiRequest } from "../index";

// Cuisine Types
export const getCuisineTypes = async ({ page = 1, limit = 10 } = {}) => {
  return apiRequest(
    `/api/admin/cuisines?page=${page}&limit=${limit}`,
    "GET"
  );
};

export const addCuisineType = async (data) => {
  return apiRequest(`/api/admin/cuisines`, "POST", data);
};

export const updateCuisineType = async (id, data) => {
  return apiRequest(`/api/admin/cuisines/${id}`, "PUT", data);
};

export const deleteCuisineType = async (id) => {
  return apiRequest(`/api/admin/cuisines/${id}`, "DELETE");
};

// Special Features
export const getSpecialFeatures = async ({ page = 1, limit = 10 } = {}) => {
  return apiRequest(
    `/api/admin/features?page=${page}&limit=${limit}`,
    "GET"
  );
};

export const addSpecialFeature = async (data) => {
  return apiRequest(`/api/admin/features`, "POST", data);
};

export const updateSpecialFeature = async (id, data) => {
  return apiRequest(`/api/admin/features/${id}`, "PUT", data);
};

export const deleteSpecialFeature = async (id) => {
  return apiRequest(`/api/admin/features/${id}`, "DELETE");
};

